import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import router from '@/router'

const request = axios.create({
  baseURL: '/api',
  timeout: 15000
})

// 请求拦截器：自动注入JWT Token
request.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers['Authorization'] = 'Bearer ' + store.state.token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理后端响应格式 { code, data, msg }
request.interceptors.response.use(
  response => {
    const resp = response.data
    const code = resp.code
    // 后端成功码：末位为1的表示成功，末位为0的表示失败
    // 成功码：20001, 20002, 20003, 20011, 20021, 20031, 20041, 20051, 20061, 20071
    // 错误码：20000, 20010, 20020, 20030, 20040, 20050, 20060, 20070, 20600, 20601, 60001
    // 系统错误：50001, 50002, 59999
    const isSuccess = (
      (code >= 20001 && code <= 20003) || // 登录成功
      (code >= 20011 && code <= 20071 && code % 10 === 1) // CRUD成功
    )
    if (isSuccess) {
      return resp
    } else {
      Message.error(resp.msg || '操作失败')
      return Promise.reject(new Error(resp.msg || '操作失败'))
    }
  },
  error => {
    let msg = '服务器异常！'
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        msg = '登录已失效，请重新登录'
        store.dispatch('logout')
        if (router.currentRoute.path !== '/login') {
          router.push('/login')
        }
      } else {
        msg = error.response.data?.msg || msg
      }
    }
    Message({
      message: msg,
      type: 'error',
      duration: 3000
    })
    return Promise.reject(error)
  }
)

export default request
